import apiService from './api.service'

const enviarEmailCartaoIndicacao = ({ oidPessoa, oidEmpresa }) => {
  return apiService.post(`/lottustech/public/email/cartaoindicacao/${oidPessoa}/${oidEmpresa}`)
}

export default { enviarEmailCartaoIndicacao }
